<!-- 采购计划编制 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="queryData"
        :field-list="fieldList"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
      ></e-search>
    </div>
    <div class="container">
      <!-- 创建方式 -->
      <div class="handle-wrapper">
        <eui-btn
          :disabled="tableSelectData.length === 0"
          font-size="12px"
          type="primary"
          @click="handleEdit('edit')"
        >
          采购计划编制
        </eui-btn>
        <eui-btn type="primary" font-size="12px" @click="handleEdit('add')"
          >手工创建</eui-btn
        >
      </div>
      <!-- table -->
      <e-table-list
        :row-key="'purchaseDemandItemId'"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="true"
        ref="multipleTable"
        @handleSelectionChange="handleSelectionChange"
        @handleSelectAll="handleSelectAll"
      >
        <template v-slot:code="tData">
          <eui-btn
            type="link"
            font-size="12px"
            @click="handleCodeDetail(tData.scope.row)"
          >
            {{ tData.scope.row.purchaseDemandCode }}
          </eui-btn>
        </template>
      </e-table-list>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          style="margin-top: 20px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :total="pageTotal"
          :page-size.sync="queryData.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import eSearch from '@/modules/projectA/components/common/e-search';
import eTableList from '@/modules/projectA/components/common/e-table-list';
import Api from '@/modules/projectA/api/purchase';
export default {
  components: {
    eSearch,
    eTableList,
  },
  data() {
    return {
      tableData: [],
      tableSelectData: [],
      pageTotal: 0,
      tableLabel: [
        {
          label: '物料分类',
          param: 'categoryName',
          align: 'center',
          fixed: 'left',
          minWidth: '140',
          tooltip: true,
        },
        {
          label: '物料编码',
          align: 'center',
          render: (row) => {
            return row.categoryCustomCode || '-';
          },
          fixed: 'left',
          minWidth: '140',
        },
        {
          label: '物料描述',
          param: 'categoryDesc',
          align: 'center',
          fixed: 'left',
          minWidth: '160',
          tooltip: true,
        },
        {
          label: '剩余未采数量',
          param: 'remainingQuantity',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '需求计划编号',
          align: 'center',
          slot: 'code',
          minWidth: '190',
        },
        {
          label: '需求计划名称',
          param: 'purchaseDemandName',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '采购数量',
          param: 'quantity',
          align: 'center',
          minWidth: '140',
        },
        {
          label: '创建日期',
          param: 'createTime',
          align: 'center',
          minWidth: '170',
        },
        {
          label: '需求部门',
          param: 'orgShortName',
          align: 'center',
          minWidth: '180',
        },
        {
          label: '需求申请人',
          param: 'createMemberName',
          align: 'center',
          minWidth: '180',
        },
      ],
      queryData: {
        purchaseDemandName: '',
        purchaseDemandCode: '',
        createTime: '',
        startTime: '',
        endTime: '',
        categoryDesc: '',
        pageNum: 1,
        pageSize: 10,
      },
      fieldList: [
        {
          label: '需求计划名称',
          type: 'input',
          value: 'purchaseDemandName',
        },
        {
          label: '需求计划编号',
          type: 'input',
          value: 'purchaseDemandCode',
        },
        {
          label: '创建日期',
          type: 'date',
          value: 'createTime',
          defaultTime: ['00:00:00', '23:59:59'],
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          dateType: 'daterange',
        },
        { label: '物料描述', type: 'input', value: 'categoryDesc' },
      ],
    };
  },
  mounted() {
    this.queryPurchaseDemandItemForPlan();
  },

  methods: {
    // 查询采购计划列表-分页查询
    async queryPurchaseDemandItemForPlan() {
      let params = { ...this.queryData };
      delete params.createTime;
      let res = await Api.queryPurchaseDemandItemForPlan(params);
      if (res.code == '200') {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },

    getRepeatNum(list) {
      return list.reduce(function (prev, next) {
        prev[next] = prev[next] + 1 || 1;
        return prev;
      }, {});
    },

    // 采购计划编制/手工创建
    handleEdit(type) {
      if (type == 'edit') {
        let titleList = this.tableSelectData.map((item) => {
          return `${item.categoryName}${item.categoryDesc}`;
        });
        let arr1 = this.getRepeatNum(titleList);
        let arr2 = [];
        for (let i in arr1) {
          let obj = {
            title: i,
            num: arr1[i],
          };
          arr2.push(obj);
        }

        this.tableSelectData.forEach((item) => {
          arr2.forEach((item2) => {
            if (`${item.categoryName}${item.categoryDesc}` == item2.title) {
              item.numFlag = item2.num;
            }
          });
        });
        if (this.tableSelectData.length) {
          this.$router.push({
            path: '/plan/purchaseWayEdit/handCreated',
            query: {
              pageType: type,
              tableSelectData: this.tableSelectData,
              tableData2: arr2,
            },
          });
        }
      } else {
        this.$router.push({
          path: '/plan/purchaseWayEdit/handCreated',
          query: {
            pageType: type,
          },
        });
      }
    },

    // 查看需求计划详情
    handleCodeDetail(row) {
      let { purchaseDemandId } = row;
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },

    // table批量选择
    handleSelectionChange(list) {
      console.log(list);
      this.tableSelectData = list;
    },
    // 全选框
    handleSelectAll(list) {
      this.tableSelectData = list;
    },

    // 查询
    handleFilter(val) {
      this.queryData = val;
      this.queryData.pageNum = 1;
      this.queryData.startTime = val.createTime ? val.createTime[0] : '';
      this.queryData.endTime = val.createTime ? val.createTime[1] : '';
      this.queryPurchaseDemandItemForPlan();
    },
    // 重置
    handleReset(val) {
      this.queryData = this.$options.data().queryData;
      this.queryPurchaseDemandItemForPlan();
    },
    // 分页
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryPurchaseDemandItemForPlan();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryPurchaseDemandItemForPlan();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  padding: 10px 20px 10px 36px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  margin-bottom: 20px;
}

::v-deep .el-table {
  th.el-table__cell > .cell {
    font-weight: normal;
    font-size: 14px;
  }
}
.btn-main-more {
  display: inline-block;
  margin-right: 10px;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  background: #2587ff;
  -webkit-user-select: none;
  border-radius: 0px;
  cursor: pointer;
  &:hover {
    background: #126edf;
  }
}
.pagination-box {
  text-align: right;
}
</style>
